<script setup>
import { __ } from '@/utils';
import Hint from '@components/hint.vue';
import { inject, computed, ref } from 'vue';

const { phone, response } = defineProps(['phone', 'response']);
const { setStep } = inject('form');

const qrURL = computed(() => {
    return response?.subscribers?.[0]?.sim.qr_url;
});

const esimAndroid = ref(simPdfGuilds.esim_android);
const esimIOS = ref(simPdfGuilds.esim_ios);
const htmlText = ref(simPdfGuilds.esim_new_line_text)
const htmlTopText = ref(simPdfGuilds.esim_new_line_top)
</script>
<template>
    <div class="congrats">
        <div class="congrats__inner">
            <img :src="`${theme_path.url}/resources/images/svg/e-sim-alt.svg`" alt="">
            <div class="congrats__heading">
                <span dir="rtl" v-html="htmlTopText"></span>
            </div>

            <div class="congrats__order-number">
                <p>
                    <strong>{{ __('line number') }} {{ phone }}</strong>
                </p>
            </div>

            <h5 class="fz18"><strong>{{ __('Still struggling? Use our guides') }}</strong></h5>

            <div class="guide-cta mb13">
                <div class="guide-cta__item">
                    <Hint />
                    <a :href="esimAndroid" target="_blank" v-if="esimAndroid">
                        {{ __('Android Guide') }}
                    </a>
                </div>
                <div class="guide-cta__item">
                    <Hint />
                    <a :href="esimIOS" target="_blank" v-if="esimIOS">
                        {{ __('IOS Guide') }}
                    </a>
                </div>
            </div>
            <div class="congrats__text-content">
                <span dir="rtl" v-html="htmlText"></span>
            </div>
            <div class="success-cta-row">
                <a href="/activation" class="link-arrow link-arrow--dark" @click.prevent="setStep('initial')">
                    {{ __('Click to activate another SIM') }}
                </a><!-- /.btn -->
                <a href="/" class="btn btn--arrows w156">{{ __('Back to Home page') }}</a>
            </div>
        </div>
    </div>
</template>